import React from "react";
import { IModirContext, IModirContextProvider } from "./types";

import { DefaultLayout } from "@components/layoutWrapper/DefaultLayout";
import { LoginPage as DefaultLoginPage } from "@components/pages";

export const ModirContext = React.createContext<IModirContext>({
  hasDashboard: false,
  warnWhenUnsavedChanges: false,
  DashboardPage: undefined,
  Title: undefined,
  Sider: undefined,
  Header: undefined,
  Footer: undefined,
  Layout: DefaultLayout,
  OffLayoutArea: undefined,
});

export const ModirContextProvider: React.FC<
  React.PropsWithChildren<IModirContextProvider>
> = ({
  hasDashboard,
  warnWhenUnsavedChanges,
  DashboardPage,
  Title,
  Layout = DefaultLayout,
  Header,
  Sider,
  Footer,
  OffLayoutArea,
  LoginPage = DefaultLoginPage,
  children,
}) => {
  return (
    <ModirContext.Provider
      value={{
        hasDashboard,
        warnWhenUnsavedChanges,
        Title,
        DashboardPage,
        Footer,
        Header,
        Layout,
        LoginPage,
        Sider,
        OffLayoutArea,
      }}
    >
      {children}
    </ModirContext.Provider>
  );
};
